"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scans = void 0;
class Scans {
    constructor(obj) {
        // Take in an object, and assign every property from that
        // object onto this newly created Scans object.
        for (const prop in obj) {
            this[prop] = obj[prop];
        }
    }
}
exports.Scans = Scans;
//# sourceMappingURL=Scans.js.map